import { CSSProperties, createContext, useState } from 'react';
import { Button, Modal, ModalProps } from 'core-ui';

interface ModalProviderPropsI {
  children: React.ReactNode;
}

interface ModalConfigI {
  title?: React.ReactNode | string;
  content?: React.ReactNode | string;
  okeButtonLabel?: string;
  cancelButtonLabel?: string;
  footer?: React.ReactNode;
  okeButtonStyle?: CSSProperties;
  cancelButtonStyle?: CSSProperties;
  modalProps?: ModalProps;
  onOke?: () => void;
  onCancel?: () => void;
  classNames?: any;
  closable?: boolean;
}

export const ModalContext = createContext({
  openModal: (_config?: ModalConfigI) => {},
  closeModal: () => {},
});

const defaultConfigs = {
  title: '',
  content: <></>,
  okeButtonLabel: '',
  cancelButtonLabel: '',
  footer: null,
  onOke: () => {},
  onCancel: () => {},
};

const ModalProvider = (props: ModalProviderPropsI) => {
  const { children } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [modalConfig, setModalConfig] = useState<ModalConfigI>(defaultConfigs);

  const openModal = (configs?: ModalConfigI) => {
    setModalConfig({ ...defaultConfigs, ...configs });
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const handleCancel = () => {
    closeModal();
    modalConfig?.onCancel?.();
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <Modal
        closable={modalConfig?.closable}
        title={modalConfig?.title}
        centered
        open={isOpen}
        classNames={modalConfig?.classNames}
        onCancel={closeModal}
        footer={modalConfig?.footer}
        {...modalConfig.modalProps}
      >
        {/*<div className="mb-[10px] justify-center flex">*/}
        {/*   <WarningIcon /> */}
        {/*</div>*/}

        <div className="mb-5">{modalConfig?.content}</div>

        <div className="flex pt-[8px] gap-[10px] justify-center">
          <Button
            style={{
              width: '147px',
              height: '36px',
              fontSize: '16px',
              ...modalConfig?.cancelButtonStyle,
            }}
            onClick={handleCancel}
          >
            {modalConfig?.cancelButtonLabel}
          </Button>
          <Button
            style={{
              width: '147px',
              height: '36px',
              fontSize: '16px',
              ...modalConfig?.okeButtonStyle,
            }}
            type="primary"
            onClick={modalConfig?.onOke}
          >
            {modalConfig?.okeButtonLabel}
          </Button>
        </div>
      </Modal>
    </ModalContext.Provider>
  );
};

export default ModalProvider;
